import useGetMyRegionPreferences from '@/api/queries/me/useGetMyRegionPreferences';
import { formatPreferredCurrency } from '@/hooks/usePreferredCurrencyFormat';
import { type EditableFixedDepositBasis } from '@payaca/helpers/editableStoredPaymentSchedule';
import { useCallback } from 'react';

/** Describes a fixed deposit in the account's currency, e.g. "£500.00, capped at 25%". */
const useDescribeFixedDeposit = () => {
  const { data: regionPreferences } = useGetMyRegionPreferences();
  const currency = regionPreferences?.currency;

  return useCallback(
    (basis: EditableFixedDepositBasis) => {
      const amount = currency
        ? formatPreferredCurrency({ value: basis.fixedAmount ?? 0, currency })
        : '';
      return basis.percentageCap === null
        ? amount
        : `${amount}, capped at ${basis.percentageCap}%`;
    },
    [currency]
  );
};

export default useDescribeFixedDeposit;
